module.exports = __webpack_public_path__ + "static/media/cdb11.3b1a9d9a.png";